import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  searchContainer: {
    borderTop: `1px solid ${themeColor.almostwhite}`,
    borderBottom: `1px solid ${themeColor.almostwhite}`,
    backgroundColor: themeColor.white,
  },
  inputRoot: {
    width: '100%',
  },
  input: {
    fontSize: rem(1.31),
    '@media (max-width: 1024px) and (max-height: 576px)': {
      fontSize: rem(1.05),
      letterSpacing: '0.5px',
    },
    paddingLeft: '1.318vw',
  },
  searchLeft: {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
    borderLeft: `1px solid ${themeColor.almostwhite}`,
  },
  searchRight: {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
    borderRight: `1px solid ${themeColor.almostwhite}`,
  },
  searchBarContainer: {
    height: '7.29vh',
    paddingRight: '0.313vw',
  },
}));
